import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import Skeleton from "react-loading-skeleton";
import { getPageRes } from "../loaders/page";
import FormComponent from "./Form/form";
import '../styles/form.css';
import {Helmet} from "react-helmet";

export default function FormPage() {
    const params = useParams();
    const entryUrl = params.page ? `/${params.page}` : "/form";
    const history = useNavigate();
    const [entry, setEntry] = useState({});
    const [error, setError] = useState(false);

    async function fetchData() {
        try {
            const result = await getPageRes(entryUrl, ['page_components.form.card_templates'], []);
            !result && setError(true);
            setEntry({ ...result });
        } catch (error) {
            setError(true);
            console.error(error);
        }
    }

    useEffect(() => {
        fetchData();
        error && history("/404");
    }, [entryUrl, error]);

    return Object.keys(entry).length ? (
        <>
            <Helmet>
                <title>{entry.seo.meta_title}</title>
                <meta name="description" content={entry.seo.meta_description} />
                <meta name="keywords" content={entry.seo.keywords} />
                {entry.seo.enable_search_indexing && <meta name="robots" content="index, follow" />}
            </Helmet>
            <FormComponent
                form={entry.page_components[0].form}
            />
        </>
    ) : (
        <Skeleton count={5} height={400} />
    );
}
